import React from "react";
import { EmbeddedReportPage } from "components";

// Компонент дашборд ABC
const ABCPage = () => {
  return (
    <EmbeddedReportPage
      pageTitle="ABC Аналіз"
      iframeTitle="Звіт по ABC"
      endpointUrl="/reports/abc/embed-url"
    />
  );
};

export default ABCPage;
